import { addProvider, IProviderDescriptor } from "../ServiceUtil";
import { HMFlowDelegate } from "./hmFlow.delegate";
import { AuthenticationService } from "../AuthenticationService/authentication.service";
import { Observable, BehaviorSubject, of as observableOf, of } from 'rxjs';
import { ICandidateResponse, ICandidate, IClientResponses, IClients, IClientSpocResponse, IClientSpoc, ICreateClient, IDeleteJobSubmissionResponse, IJobCode, IJobCodeResponse, IJobSubmission, IJobSubmissionResponse, INewCandidate, INewCandidateBulk, INewClientSpoc, INewJCTAMapping, INewJobCode, INewJobSubmission, IInterViewPanel, ICandidateFilter, IJobCodeFilter, INewCandidateDocument, IInterViewPanelResponse, INewInterViewPanel, IJobInterview, INewJobInterview, IJobInterviewResponse, ICreatedMultiSelectJS, MultiselectCJC, ICreateMultiSelectCJCResponse, ITAMember, ITAMemberResponse, INewClientSpocBulk, INewJobCodeDocument, IJobCodeDocumentsResponse, IUploadResumeRequest, IUploadResumeResponse, IUploadBulkResumesRequest, IUploadBulkResumesResponse, IQueryResumesRequest, IMatchJobDescriptionRequest, IResumeQueryResult } from "./hmFlow.interface";
import { mergeMap, catchError, share, map } from "rxjs/operators";
import { ConfigService } from "../ConfigService";
import { Role } from "../AuthenticationService/authentication.interface";

export class HMFlowService
{

    private candidateData: ICandidate[] = null;
    private candidateSubject: BehaviorSubject<ICandidate[]> = new BehaviorSubject(null);
    public candidate: Observable<ICandidate[]> = this.candidateSubject;

    private candidatePaginationData: { totalCount: number; pageNumber: number; pageSize: number; totalPages: number } = null;
    private candidatePaginationSubject: BehaviorSubject<{ totalCount: number; pageNumber: number; pageSize: number; totalPages: number }> = new BehaviorSubject(null);
    public candidatePagination: Observable<{ totalCount: number; pageNumber: number; pageSize: number; totalPages: number }> = this.candidatePaginationSubject;

    private selectedCandidateData: ICandidate = null;
    private selectedCandidateSubject: BehaviorSubject<ICandidate> = new BehaviorSubject(this.selectedCandidateData);
    public selectedCandidate: Observable<ICandidate> = this.selectedCandidateSubject;

    private candidateFilteredSubject: BehaviorSubject<IJobCode[]> = new BehaviorSubject(null);
    public candidateFiltered: Observable<IJobCode[]> = this.candidateFilteredSubject;

    private jobCodeData: IJobCode[] = null;
    private jobCodeSubject: BehaviorSubject<IJobCode[]> = new BehaviorSubject(null);
    public jobCodes: Observable<IJobCode[]> = this.jobCodeSubject;

    private selectedJobCodeData: IJobCode = null;
    private selectedJobCodeSubject: BehaviorSubject<IJobCode> = new BehaviorSubject(this.selectedJobCodeData);
    public selectedJobCode: Observable<IJobCode> = this.selectedJobCodeSubject;

    private jobCodeFilteredSubject: BehaviorSubject<IJobCode[]> = new BehaviorSubject(null);
    public jobCodeFiltered: Observable<IJobCode[]> = this.jobCodeFilteredSubject;

    private clientSpocData: IClientSpoc[] = null;
    private clientSpocSubject: BehaviorSubject<IClientSpoc[]> = new BehaviorSubject(null);
    public clientspocs: Observable<IClientSpoc[]> = this.clientSpocSubject;

    private selectedClientSpocData: IClientSpoc = null;
    private selectedClientSpocSubject: BehaviorSubject<IClientSpoc> = new BehaviorSubject(this.selectedClientSpocData);
    public selectedClientSpoc: Observable<IClientSpoc> = this.selectedClientSpocSubject;

    private clientSpocFilteredSubject: BehaviorSubject<IClientSpoc[]> = new BehaviorSubject(null);
    public clientSpocFiltered: Observable<IClientSpoc[]> = this.clientSpocFilteredSubject;

    private jobSubmissionData: IJobSubmission[] = null;
    private jobSubmissionSubject: BehaviorSubject<IJobSubmission[]> = new BehaviorSubject(null);
    public jobSubmissions: Observable<IJobSubmission[]> = this.jobSubmissionSubject;

    private selectedJobSubmissionData: IJobSubmission = null;
    private selectedJobSubmissionSubject: BehaviorSubject<IJobSubmission> = new BehaviorSubject(this.selectedJobSubmissionData);
    public selectedJobSubmission: Observable<IJobSubmission> = this.selectedJobSubmissionSubject;

    private selectedClientspocClientData: IClients = null;
    private selectedClientspocClientSubject: BehaviorSubject<IClients> = new BehaviorSubject(this.selectedClientspocClientData);
    public selectedClientspocClient: Observable<IClients> = this.selectedClientspocClientSubject;

    private selectedInterviewPanelData: IInterViewPanel = null;
    private selectedInterviewPanelSubject: BehaviorSubject<IInterViewPanel> = new BehaviorSubject(this.selectedInterviewPanelData);
    public selectedInterviewPanel: Observable<IInterViewPanel> = this.selectedInterviewPanelSubject;

    private interviewPanelData: IInterViewPanel[] = null;
    private interviewPanelSubject: BehaviorSubject<IInterViewPanel[]> = new BehaviorSubject(this.interviewPanelData);
    public interviewPanel: Observable<IInterViewPanel[]> = this.interviewPanelSubject;

    private selectedJobInterviewData: IJobInterview = null;
    private selectedJobInterviewSubject: BehaviorSubject<IJobInterview> = new BehaviorSubject(this.selectedJobInterviewData);
    public selectedJobInterview: Observable<IJobInterview> = this.selectedJobInterviewSubject;

    private interviewData: IJobInterview[] = null;
    private interviewSubject: BehaviorSubject<IJobInterview[]> = new BehaviorSubject(this.interviewData);
    public interview: Observable<IJobInterview[]> = this.interviewSubject;
    private taMembersData: ITAMember[] = null;
    private taMembersSubject: BehaviorSubject<ITAMember[]> = new BehaviorSubject<ITAMember[]>(null);
    public taMembers: Observable<ITAMember[]> = this.taMembersSubject;

    constructor(private hmFlowDelegate: HMFlowDelegate, private authenticationService: AuthenticationService, private configServices: ConfigService)
    {

    }
    private selectedCandidateId: string = "0";
    private selectedJobCodeId: string = "0";
    private selectedJobSubmissionId: string = "0";
    private selectedClientSpocId: string = "0";
    private selectedClientId: string = "0";
    private selectedInterviewPanelId: string = "0";
    private selectedJobInterviewId: string = "0";
    public filterJobCodeStatus: boolean = true;
    public filterClientSpocStatus: boolean = true;

    public get isHMUser(): boolean
    {
        return this.authenticationService.hasRole(Role.HMUser);
    }

    public get loggedInTAId(): string
    {
        return this.authenticationService.GetEmployeeId();
    }

    public get candidateId(): string
    {
        return this.selectedCandidateId;
    }
    public setSelectedCandidateId(candidateId: string): void
    {
        this.selectedCandidateId = candidateId;
    }
    public get jobCodeId(): string
    {
        return this.selectedJobCodeId;
    }

    public setSelectedJobCode(jobCodeId: string): void
    {
        this.selectedJobCodeId = jobCodeId;
    }

    public get clientSpocId(): string
    {
        return this.selectedClientSpocId;
    }
    public setSelectedClientSpocId(clientSpocId: string): void
    {
        this.selectedClientSpocId = clientSpocId;
    }
    public get jobSubmissionId(): string
    {
        return this.selectedJobSubmissionId;
    }
    public setSelectedJobSubmission(jobSubmissionId: string): void
    {
        this.selectedJobSubmissionId = jobSubmissionId;
    }

    public get clientId(): string
    {
        return this.selectedClientId;
    }
    public setSelectedClientId(clientId: string): void
    {
        this.selectedClientId = clientId;
    }

    public get interviewPanelAvailabilityId(): string
    {
        return this.selectedInterviewPanelId;
    }
    public setSelectedInterviewPanelId(interviewPanelAvailabilityId: string): void
    {
        this.selectedInterviewPanelId = interviewPanelAvailabilityId;
    }

    public get jobInterviewId(): string
    {
        return this.selectedJobInterviewId;
    }
    public setSelectedJobInterviewId(jobInterviewId: string): void
    {
        this.selectedJobInterviewId = jobInterviewId;
    }

    public getCandidateById(id: string): ICandidate
    {
        return this.candidateData?.find(c => c.candidateId === id);
    }

    public getJobCodeById(id: string): IJobCode
    {
        return this.jobCodeData?.find(jc => jc.jobCodeId === id);
    }

    public getAllCandidates(pageNumber: number = 1, pageSize: number = 50, searchTerm?: string): Observable<boolean>
    {
        const orgId = this.authenticationService.GetOrgId();
        const taId = this.authenticationService.GetEmployeeId();
        const response = this.hmFlowDelegate.getAllHmCandidates(orgId, taId, pageNumber, pageSize, searchTerm);
        return this.processCandidates(response);
    }

    public createNewCandidate(candidate: INewCandidate): Observable<boolean>
    {
        const response = this.hmFlowDelegate.createNewCandidate({
            ...candidate,
            ...this.authenticationService.getBaseRequest
        });
        return this.processCandidate(response, false);
    }

    public updateCandidate(candidate: ICandidate): Observable<boolean>
    {
        const response = this.hmFlowDelegate.updateCandidate({
            ...candidate,
            ...this.authenticationService.getBaseRequest
        });
        return this.processCandidate(response, true);
    }

    public getCandidateDetailsById(candidateId: string): Observable<boolean>
    {
        if (candidateId === "0")
        {
            this.selectedCandidateData = null;
            this.selectedCandidateSubject.next(this.selectedCandidateData);
            return observableOf(false);
        }
        var response = this.hmFlowDelegate.getCandidateByCandidateId(candidateId);
        return this.processCandidate(response, true);
    }

    public createNewCandidateDocuments(candidateDocuments: INewCandidateDocument): Observable<boolean>
    {
        const response = this.hmFlowDelegate.createCandidateDocument({ ...candidateDocuments, ...this.authenticationService.getBaseRequest });
        return this.processCandidate(response);
    }

    public uploadJobCodeDocument(jobCodeDocument: INewJobCodeDocument): Observable<boolean>
    {
        const payload: INewJobCodeDocument = { ...jobCodeDocument, ...this.authenticationService.getBaseRequest };
        return this.hmFlowDelegate.uploadJobCodeDocument(payload).pipe(
            mergeMap((response: IJobCodeDocumentsResponse) =>
            {
                return of(response.success === true);
            }),
            catchError(() => of(false))
        );
    }

    public getAllJobCodes(forceRefresh: boolean = false): Observable<boolean>
    {
        if (!forceRefresh && this.jobCodeData !== null && this.jobCodeData.length > 0)
        {
            return observableOf(true);
        }
        const orgId = this.authenticationService.GetOrgId();
        const taId = this.authenticationService.GetEmployeeId();
        const response = this.hmFlowDelegate.getAllJobCodes(orgId, taId);
        return this.processJobCodes(response);
    }

    public getJobCodeDetailsById(jobCodeId: string): Observable<boolean>
    {
        if (jobCodeId === "0")
        {
            this.selectedJobCodeData = null;
            this.selectedJobCodeSubject.next(this.selectedJobCodeData);
            return observableOf(false);
        }
        var response = this.hmFlowDelegate.getJobCodeByJobCodeId(jobCodeId);

        return this.processJobCode(response, true);
    }

    public createNewJobCode(jobCode: INewJobCode): Observable<boolean>
    {
        const response = this.hmFlowDelegate.createNewJobCode({
            ...jobCode,
            orgId: this.authenticationService.getBaseRequest.orgId,
            userName: this.authenticationService.getBaseRequest.userName
        });
        return this.processJobCode(response, false);
    }
    public updateJobCode(jobcode: IJobCode): Observable<boolean>
    {
        const response = this.hmFlowDelegate.updateJobCode({
            ...jobcode,
            orgId: this.authenticationService.getBaseRequest.orgId,
            userName: this.authenticationService.getBaseRequest.userName
        });
        return this.processJobCode(response, true);
    }

    public createNewJcTA(assign: INewJCTAMapping): Observable<boolean>
    {

        const response = this.hmFlowDelegate.assignTAJC({
            ...assign,
            userName: this.authenticationService.getBaseRequest.userName
        });
        return this.processTAJobCode(response);
    }

    public unAssignJcTA(taid: string, jobcodeId: string): Observable<boolean>
    {

        const response = this.hmFlowDelegate.unAssignTAJC({
            taid: taid,
            jobCodeId: jobcodeId,
            userName: this.authenticationService.getBaseRequest.userName
        });

        return this.processTAJobCode(response);
    }

    public createJobSubmission(jobSubmission: MultiselectCJC): Observable<ICreateMultiSelectCJCResponse>
    {
        const response = this.hmFlowDelegate.createNewJobSubmission({
            ...jobSubmission,
            userName: this.authenticationService.getBaseRequest.userName
        });
        return this.processMultiJobSubmissions(response);
    }

    public updateJobSubmission(jobSubmission: IJobSubmission): Observable<boolean>
    {
        const response = this.hmFlowDelegate.updateJobSubmission({
            ...jobSubmission,
            ...this.authenticationService.getBaseRequest
        });
        return this.processJobSubmission(response, true);
    }

    public getJobSubmissionById(jobSubmissionId: string): Observable<boolean>
    {
        if (jobSubmissionId === "0")
        {
            this.selectedJobSubmissionData = null;
            this.selectedJobSubmissionSubject.next(this.selectedJobSubmissionData);
            return observableOf(false);
        }
        var response = this.hmFlowDelegate.getJobSubmissionById(jobSubmissionId);
        return this.processJobSubmission(response, true);
    }

    public getAllJobSubmissions(forceRefresh: boolean = false): Observable<boolean>
    {
        if (!forceRefresh && this.jobSubmissionData !== null && this.jobSubmissionData.length > 0)
        {
            return observableOf(true);
        }
        const orgId = this.authenticationService.GetOrgId();
        const taId = this.authenticationService.GetEmployeeId();
        const response = this.hmFlowDelegate.getAllJobSubmissions(orgId, taId);
        return this.processJobSubmissions(response);
    }

    public getAllTAMembers(forceRefresh: boolean = false): Observable<boolean>
    {
        if (!forceRefresh && this.taMembersData !== null && this.taMembersData.length > 0)
        {
            return observableOf(true);
        }
        const orgId = this.authenticationService.GetOrgId();
        const clientId = this.authenticationService.GetClientId();
        const employeeId = this.authenticationService.GetEmployeeId();
        const response = this.hmFlowDelegate.getAllTAMembers(orgId, clientId, employeeId);
        response.subscribe(
            (res: ITAMemberResponse) =>
            {
                this.taMembersData = res.taMembers;
                this.taMembersSubject.next(this.taMembersData);
            },
            (_error: any) => { /* HMFlowService.logger.error(getAllTAMembers) */ }
        );
        return response.pipe(
            mergeMap((res: ITAMemberResponse) => !res ? observableOf(false) : observableOf(true)),
            catchError(() => observableOf(false)),
            share());
    }

    public deleteJobSubmission(jobSubmissionId: string): Observable<boolean>
    {
        var config = this.hmFlowDelegate.deleteJobSubmission(jobSubmissionId);
        config.subscribe(onConfigurationSuccess.bind(this), onConfigurationFault.bind(this));
        return config.pipe(
            mergeMap((response: IDeleteJobSubmissionResponse) => observableOf(response.success)),
            catchError(() => observableOf(false)),
            share()
        );
        function onConfigurationSuccess(response: IDeleteJobSubmissionResponse)
        {
            if (response.success)
            {
                this.jobSubmissionData = this.jobSubmissionData.filter(
                    x => x.jobSubmissionId !== jobSubmissionId
                );
                this.jobSubmissionSubject.next(this.jobSubmissionData);
            }
        }

        function onConfigurationFault(error: any)
        {
            // handle error
        }
    }

    public getClientSpocDetailsById(clientSpocId: string): Observable<boolean>
    {
        if (clientSpocId === "0")
        {
            this.selectedClientSpocData = null;
            this.selectedClientSpocSubject.next(this.selectedClientSpocData);
            return observableOf(false);
        }
        var response = this.hmFlowDelegate.getClientspocByClientspocId(clientSpocId);
        return this.processClientspoc(response, true);
    }

    public getAllclientspocs(forceRefresh: boolean = false): Observable<boolean>
    {
        if (!forceRefresh && this.clientSpocData !== null && this.clientSpocData.length > 0)
        {
            return observableOf(true);
        }
        const response = this.hmFlowDelegate.getAllClientSpocs();
        return this.processClientspocs(response);
    }

    public createClientSpoc(clientSpoc: INewClientSpoc): Observable<boolean>
    {
        const response = this.hmFlowDelegate.createNewClientSpoc({
            ...clientSpoc,
            userName: this.authenticationService.getBaseRequest.userName
        });
        return this.processClientspoc(response, false);
    }

    public createClientSpocBulk(clientSpoc: INewClientSpocBulk): Observable<boolean>
    {
        const response = this.hmFlowDelegate.createNewClientSpocBulk({
            ...clientSpoc,
            orgId: this.authenticationService.getBaseRequest.orgId,
            clientId: this.authenticationService.GetClientId(),
            userName: this.authenticationService.getBaseRequest.userName
        });
        return this.processClientspocs(response);
    }

    public updateClientSpoc(clientSpoc: IClientSpoc): Observable<boolean>
    {
        const response = this.hmFlowDelegate.updateClientSpoc({
            ...clientSpoc,
            userName: this.authenticationService.getBaseRequest.userName
        });
        return this.processClientspoc(response, true);
    }

    public createClient(jobCode: ICreateClient): Observable<boolean>
    {
        const response = this.hmFlowDelegate.createClient({
            ...jobCode,
            userName: this.authenticationService.getBaseRequest.userName
        });
        return this.processClient(response);
    }

    public updateClient(jobCode: IClients): Observable<boolean>
    {
        const response = this.hmFlowDelegate.updateClient({
            ...jobCode,
            userName: this.authenticationService.getBaseRequest.userName
        });
        return this.processClient(response);
    }
    
    public updateDefaultClientId( userId: string, clientId: string): Observable<boolean>
    {
        return this.hmFlowDelegate.updateDefaultClient(
            userId,
            clientId
        );
    }

    public getClientSpocClientDetailsById(clientId: string): Observable<boolean>
    {
        if (clientId === "0")
        {
            this.selectedClientspocClientData = null;
            this.selectedClientspocClientSubject.next(this.selectedClientspocClientData);
            return observableOf(false);
        }
        var response = this.hmFlowDelegate.getClientById(clientId);
        return this.processClient(response);
    }

    public uploadResume(request: IUploadResumeRequest): Observable<IUploadResumeResponse>
    {
        request.orgId = this.authenticationService.getBaseRequest.orgId;
        request.taid =  this.authenticationService.GetEmployeeId();
        return this.hmFlowDelegate.uploadResume(request).pipe(
            mergeMap((response: IUploadResumeResponse) =>
            {
                if (response.success)
                {
                    // Refresh the candidate list so the newly created/updated candidate shows up
                    this.getAllCandidates();
                }
                return of(response);
            })
        );
    }

    public uploadBulkResumes(request: IUploadBulkResumesRequest): Observable<IUploadBulkResumesResponse>
    {
        request.orgId = request.orgId || this.authenticationService.getBaseRequest.orgId;
        request.taid = request.taid || this.authenticationService.GetEmployeeId();
        return this.hmFlowDelegate.uploadBulkResumes(request).pipe(
            mergeMap((response: IUploadBulkResumesResponse) =>
            {
                if (response.succeeded > 0)
                {
                    // Refresh the candidate list so newly created/updated candidates show up
                    this.getAllCandidates();
                }
                return of(response);
            })
        );
    }

    public queryResumes(request: IQueryResumesRequest): Observable<IResumeQueryResult>
    {
        request.orgId = request.orgId || this.authenticationService.getBaseRequest.orgId;
        request.taid = request.taid || this.authenticationService.GetEmployeeId();
        request.topK = request.topK || 5;
        return this.hmFlowDelegate.queryResumes(request);
    }

    public matchJobDescription(request: IMatchJobDescriptionRequest): Observable<IResumeQueryResult>
    {
        request.orgId = request.orgId || this.authenticationService.getBaseRequest.orgId;
        request.taid = request.taid || this.authenticationService.GetEmployeeId();
        request.topK = request.topK || 5;
        return this.hmFlowDelegate.matchJobDescription(request);
    }

    // ATS assistant (chatbot) state is kept here, on the singleton service,
    // rather than on the chatbot component itself. The chatbot component can
    // be destroyed/recreated as the user navigates between routes (e.g. into
    // a candidate detail page and back), which would otherwise reset its
    // local fields and make the last search results disappear.
    public atsChatbotState: {
        isOpen: boolean;
        mode: 'ask' | 'match';
        question: string;
        jobDescription: string;
        result: IResumeQueryResult | null;
        errorMessage: string;
    } = {
        isOpen: false,
        mode: 'ask',
        question: '',
        jobDescription: '',
        result: null,
        errorMessage: ''
    };

    public createNewCandidateBulk(candidate: INewCandidateBulk): Observable<boolean>
    {
        candidate.userName = this.authenticationService.getBaseRequest.userName;
        candidate.orgId = this.authenticationService.getBaseRequest.orgId;
        candidate.taid = this.isHMUser ? this.authenticationService.GetUserId() : null;
        candidate.clientTimeStamp = this.authenticationService.getBaseRequest.clientTimeStamp;
        const response = this.hmFlowDelegate.createNewCandidateBulk(candidate);
        return this.processCandidates(response);
    }
    public createNewJobCodeBulk(jobcode: INewCandidateBulk): Observable<boolean>
    {
        jobcode.userName = this.authenticationService.getBaseRequest.userName;
        jobcode.orgId = this.authenticationService.getBaseRequest.orgId;
        jobcode.taid = this.isHMUser ? this.authenticationService.GetUserId() : null;
        jobcode.clientTimeStamp = this.authenticationService.getBaseRequest.clientTimeStamp;
        const response = this.hmFlowDelegate.createNewJobCodeBulk(jobcode);
        return this.processJobCodes(response);
    }
    public createNewJobSubmissionBulk(jobsubmission: INewCandidateBulk): Observable<boolean>
    {
        jobsubmission.userName = this.authenticationService.getBaseRequest.userName;
        jobsubmission.orgId = this.authenticationService.getBaseRequest.orgId;
        jobsubmission.taid = this.isHMUser ? this.authenticationService.GetUserId() : null;
        jobsubmission.clientTimeStamp = this.authenticationService.getBaseRequest.clientTimeStamp;
        const response = this.hmFlowDelegate.createNewJobSubmissionBulk(jobsubmission);
        return this.processJobSubmissions(response);
    }

    public getAllInterviews(): Observable<boolean>
    {
        if (this.interviewData !== null && this.interviewData.length > 0)
        {
            return observableOf(true);
        }
        const orgId = this.authenticationService.GetOrgId();
        const taid = this.isHMUser ? this.authenticationService.GetUserId() : null;
        const response = this.hmFlowDelegate.getAllJobInterviews(orgId,taid);
        return this.processJobInterviews(response);
    }

    public getJobInterviewById(jobInterviewId: string): Observable<boolean>
    {
        if (jobInterviewId === "0")
        {
            this.selectedJobInterviewData = null;
            this.selectedJobInterviewSubject.next(this.selectedJobInterviewData);
            return observableOf(false);
        }
        var response = this.hmFlowDelegate.getJobInterviewById(jobInterviewId);

        return this.processJobInterview(response, true);
    }

    public createNewJobInterview(jobInterview: INewJobInterview): Observable<boolean>
    {
        const response = this.hmFlowDelegate.createNewJobInerview({
            ...jobInterview,
            userName: this.authenticationService.getBaseRequest.userName
        });
        return this.processJobInterview(response, false);
    }
    public updateJobInterview(jobcode: IJobInterview): Observable<boolean>
    {
        const response = this.hmFlowDelegate.updateJobInterview({
            ...jobcode,
            userName: this.authenticationService.getBaseRequest.userName
        });
        return this.processJobInterview(response, true);
    }

    public createInterviewPanel(interviewpanel: INewInterViewPanel): Observable<boolean>
    {
        interviewpanel.userName = this.authenticationService.getBaseRequest.userName;
        const response = this.hmFlowDelegate.createNewInterviewPanel(interviewpanel);
        return this.processInterviewPanel(response);
    }

    public updateInterviewPanel(interviewpanel: IInterViewPanel): Observable<boolean>
    {
        interviewpanel.userName = this.authenticationService.getBaseRequest.userName;
        const response = this.hmFlowDelegate.updateInterviewPanel(interviewpanel);
        return this.processInterviewPanel(response);
    }

    public getInterviewPaneldetailsById(interviewPanelAvailabilityId?: string): Observable<boolean>
    {

        if (interviewPanelAvailabilityId === "0")
        {
            this.selectedInterviewPanelData = null;
            this.selectedInterviewPanelSubject.next(this.selectedInterviewPanelData);
            return observableOf(false);
        }
        var response = this.hmFlowDelegate.getInterviewPanelAvailabilityById(interviewPanelAvailabilityId);
        return this.processInterviewPanel(response);
    }

    public getInterviewPanelsWithFreeSlots(jobCodeId: string, slotMinutes: number = 0): Observable<IInterViewPanel[]>
    {
        return this.hmFlowDelegate.getInterviewPanelsWithFreeSlots(jobCodeId, slotMinutes)
            .pipe(map((r: IInterViewPanelResponse) => r.interviewPanelAvailabilities || []));
    }

    public getOrgInterviewPanels(): Observable<IInterViewPanel[]>
    {
        const orgId = this.authenticationService.GetOrgId();
        const employeeId = this.authenticationService.GetEmployeeId();
        return this.hmFlowDelegate.getOrgInterviewPanels(orgId, employeeId)
            .pipe(map((r: IInterViewPanelResponse) => r.interviewPanelAvailabilities || []));
    }

    public getAllInterviewPanel(jobCodeId?: string): Observable<boolean>
    {
        const response = this.hmFlowDelegate.getAllInterviewPanels(jobCodeId);
        return this.processInterviewPanels(response);
    }

    public getJobCodeByStatus(active: boolean)
    {
        this.filterJobCodeStatus = active;
        let data = this.jobCodeData;
        data = (this.jobCodeData || []).filter(x => x.jobCodeStatus === active);
        this.jobCodeFilteredSubject.next(data);
    }

    public getClientspocByStatus(status: boolean)
    {
        this.filterClientSpocStatus = status;
        let data = this.clientSpocData;
        data = (this.clientSpocData || []).filter(x => x.status === status);
        this.clientSpocFilteredSubject.next(data);
    }

    public filterClientSpocs(searchTerm: string, filterBy: string)
    {
        let data = this.clientSpocData;
        if (filterBy == null)
        {
            data = this.clientSpocData.filter(x =>
                x.firstName.trim().toLowerCase().includes(searchTerm.trim().toLowerCase()) ||
                x.lastName.trim().toLowerCase().includes(searchTerm.trim().toLowerCase()) ||
                x.emailAddress.trim().toLowerCase().includes(searchTerm.trim().toLowerCase())
            );
        }
        else
        {
            data = this.clientSpocData.filter(x =>
                x[filterBy].trim().toLowerCase().includes(searchTerm.trim().toLowerCase())
            );
        }
        this.clientSpocSubject.next(data);
    }

    public filterCandidate(searchTerm: string, filterBy: string)
    {
        let data = this.candidateData;
        if (filterBy == null)
        {
            data = this.candidateData.filter(x =>
                x.firstName.trim().toLowerCase().includes(searchTerm.trim().toLowerCase()) ||
                x.lastName.trim().toLowerCase().includes(searchTerm.trim().toLowerCase()) ||
                x.emailAddress.trim().toLowerCase().includes(searchTerm.trim().toLowerCase())
            );
        }
        else
        {
            data = this.candidateData.filter(x =>
                x[filterBy].trim().toLowerCase().includes(searchTerm.trim().toLowerCase())
            );
        }
        this.candidateSubject.next(data);
    }

    resetCandidateFilter(): void
    {
        this.candidateSubject.next(this.candidateData)
    }

    public filterCandidates(filter: ICandidateFilter): void
    {
        const filteredData = this.candidateData.filter((c: ICandidate) =>
        {
            return (
                (!filter.city ||
                    c.city.toLowerCase().includes(filter.city.toLowerCase())) &&

                (!filter.state ||
                    c.state.toLowerCase().includes(filter.state.toLowerCase())) &&

                (!filter.noOfYearsExperience ||
                    (c.noOfYearsExperience || 0) >= filter.noOfYearsExperience) &&

                (!filter.noOfYearsRelativeExperience ||
                    (c.noOfYearsRelativeExperience || 0) >= filter.noOfYearsRelativeExperience) &&

                (!filter.noticePeriod ||
                    (c.noticePeriod || 0) <= filter.noticePeriod) &&

                (!filter.currentPay ||
                    (c.currentPay || 0) <= filter.currentPay) &&

                (!filter.expectedPay ||
                    (c.expectedPay || 0) <= filter.expectedPay) &&

                this.matchSkills(this.getCombinedSkills(c), filter.skillSet)
            );
        });

        this.candidateSubject.next(filteredData);
    }

    private getCombinedSkills(candidate: ICandidate): string[]
    {
        return [
            ...(candidate.skillSet || []),
            ...(candidate.skillSetPrimary || []),
            ...(candidate.skillSetSecondary || [])
        ];
    }
    private matchSkills(candidateSkills?: string[], filterSkills?: string[]): boolean
    {

        if (!filterSkills || filterSkills.length === 0)
        {
            return true;
        }

        if (!candidateSkills || candidateSkills.length === 0)
        {
            return false;
        }

        return filterSkills.every(fs =>
            candidateSkills.some(cs =>
                cs.toLowerCase() === fs.toLowerCase()
            )
        );
    }

    resetJobCodeFilter(): void
    {
        this.jobCodeFilteredSubject.next(this.jobCodeData);
    }

    public filterjobCode(filter: IJobCodeFilter): void
    {
        const filteredData = this.jobCodeData.filter((c: IJobCode) =>
        {
            return (
                (!filter.clientJobCodeNumber ||
                    c.clientJobCodeNumber.toLowerCase().includes(filter.clientJobCodeNumber.toLowerCase())) &&

                (!filter.location ||
                    c.location.toLowerCase().includes(filter.location.toLowerCase())) &&

                (!filter.jobTitle ||
                    c.jobTitle.toLowerCase().includes(filter.jobTitle.toLowerCase())) &&

                (!filter.minCTC ||
                    (c.ctc || 0) >= filter.minCTC) &&

                (!filter.maxCTC ||
                    (c.ctc || 0) <= filter.maxCTC) &&

                (!filter.bandLevelId ||
                    c.bandLevelId === filter.bandLevelId) &&

                (!filter.jobType ||
                    c.jobType === filter.jobType) &&

                this.matchSkills(c.skillset, filter.skillset)
            );
        });

        this.jobCodeFilteredSubject.next(filteredData);
    }

    private processCandidates(response: Observable<ICandidateResponse>): Observable<boolean>
    {
        response.subscribe(onCandidateSuccess.bind(this), onCandidateFault.bind(this));
        return response.pipe(mergeMap((response: ICandidateResponse) => observableOf(response.success)),
            catchError(() => observableOf(false)),
            share());
        function onCandidateSuccess(candidateResponse: ICandidateResponse)
        {
            if (candidateResponse.success && candidateResponse.candidates.length > 0)
            {
                this.selectedCandidateId = candidateResponse.candidateId ? candidateResponse.candidateId : this.selectedCandidateId;
                this.candidateData = [...candidateResponse.candidates].sort(sortByCreatedDateDesc);
                this.candidateSubject.next(this.candidateData);
                this.candidateFilteredSubject.next(this.candidateData);

                // Store pagination data
                if (candidateResponse.totalCount !== undefined)
                {
                    this.candidatePaginationData = {
                        totalCount: candidateResponse.totalCount,
                        pageNumber: candidateResponse.pageNumber,
                        pageSize: candidateResponse.pageSize,
                        totalPages: candidateResponse.totalPages
                    };
                    this.candidatePaginationSubject.next(this.candidatePaginationData);
                }
            }
        }
        function onCandidateFault(error: any)
        {
            //EmployeeService.logger.error(`processEmployees Fault - Error (${JSON.stringify(error)})`);
        }
        function sortByCreatedDateDesc(a: ICandidate, b: ICandidate): number
        {
            const aTime = a.createdDateTime ? new Date(a.createdDateTime).getTime() : 0;
            const bTime = b.createdDateTime ? new Date(b.createdDateTime).getTime() : 0;
            return bTime - aTime;
        }
    }

    private processCandidate(response: Observable<ICandidateResponse>, update: boolean = true): Observable<boolean>
    {
        response.subscribe(onCandidateSuccess.bind(this), onCandidateFault.bind(this));
        return response.pipe(mergeMap((response: ICandidateResponse) => observableOf(response.success)),
            catchError(() => observableOf(false)),
            share());
        function onCandidateSuccess(candidateResponse: ICandidateResponse)
        {
            if (candidateResponse.success && candidateResponse.candidate)
            {
                this.selectedCandidateId = candidateResponse.candidateId ? candidateResponse.candidateId : this.selectedCandidateId;
                this.selectedCandidateData = candidateResponse.candidate;
                this.selectedCandidateSubject.next(this.selectedCandidateData);
                if (this.candidateData)
                {
                    if (update)
                    {
                        const index = this.candidateData.findIndex(x => x.candidateId === this.selectedCandidateData.candidateId);
                        this.candidateData[index] = this.selectedCandidateData;
                    }
                    else
                    {
                        this.candidateData.push(candidateResponse.candidate);
                    }
                    this.candidateSubject.next(this.candidateData);
                }
            }
        }

        function onCandidateFault(error: any)
        {
            //EmployeeService.logger.error(`processEmployees Fault - Error (${JSON.stringify(error)})`);
        }
    }

    private processJobCode(response: Observable<IJobCodeResponse>, update: boolean = true): Observable<boolean>
    {
        response.subscribe(onJobCodeSuccess.bind(this), onJobCodeFault.bind(this));
        return response.pipe(mergeMap((response: IJobCodeResponse) => observableOf(response.success)),
            catchError(() => observableOf(false)),
            share());
        function onJobCodeSuccess(jobcodeResponse: IJobCodeResponse)
        {
            if (jobcodeResponse.success && jobcodeResponse.jobCode)
            {
                this.selectedJobCodeId = jobcodeResponse.jobCodeId ? jobcodeResponse.jobCodeId : this.selectedJobCodeId;
                this.selectedJobCodeData = jobcodeResponse.jobCode;
                this.selectedJobCodeSubject.next(this.selectedJobCodeData);
                if (this.jobCodeData)
                {
                    if (update)
                    {
                        let data = this.jobCodeData;
                        const index = this.jobCodeData.findIndex(x => x.jobCodeId === this.selectedJobCodeData.jobCodeId);
                        this.jobCodeData[index] = this.selectedJobCodeData;
                        data = this.jobCodeData.filter(x => x.jobCodeStatus === this.filterJobCodeStatus);
                        this.jobCodeFilteredSubject.next(data);
                        this.jobCodeSubject.next(this.jobCodeData.filter(x => x.jobCodeStatus === true));
                    }
                    else
                    {
                        this.jobCodeData.push(jobcodeResponse.jobCode);
                        const filteredData = this.isHMUser ? this.jobCodeData.filter(x => x.jobCodeStatus === true &&
                            x.jctamappings.find(m => m.taid === this.loggedInTAId)) : this.jobCodeData.filter(x => x.jobCodeStatus === true)
                        this.jobCodeFilteredSubject.next(filteredData);

                    }
                }

            }
        }
        function onJobCodeFault(error: any)
        {
            //EmployeeService.logger.error(`processEmployees Fault - Error (${JSON.stringify(error)})`);
        }
    }

    private processJobCodes(response: Observable<IJobCodeResponse>): Observable<boolean>
    {
        response.subscribe(onJobCodeSuccess.bind(this), onJobCodeFault.bind(this));
        return response.pipe(mergeMap((response: IJobCodeResponse) => observableOf(response.success)),
            catchError(() => observableOf(false)),
            share());
        function onJobCodeSuccess(jobcodeResponse: IJobCodeResponse)
        {
            if (jobcodeResponse.success && jobcodeResponse.jobCodes.length > 0)
            {
                this.selectedJobCodeId = jobcodeResponse.jobCodeId ? jobcodeResponse.jobCodeId : this.selectedJobCodeId;
                this.jobCodeData = jobcodeResponse.jobCodes;
                this.jobCodeSubject.next(this.jobCodeData.filter(x => x.jobCodeStatus === true))
                this.jobCodeFilteredSubject.next(this.jobCodeData)
                this.getJobCodeByStatus(this.filterJobCodeStatus);
            }
        }
        function onJobCodeFault(error: any)
        {
            //EmployeeService.logger.error(`processEmployees Fault - Error (${JSON.stringify(error)})`);
        }
    }

    private processTAJobCode(response: Observable<IJobCodeResponse>): Observable<boolean>
    {
        response.subscribe(onJobCodeSuccess.bind(this), onJobCodeFault.bind(this));
        return response.pipe(mergeMap((response: IJobCodeResponse) => observableOf(response.success)),
            catchError(() => observableOf(false)),
            share());
        function onJobCodeSuccess(jobcodeResponse: IJobCodeResponse)
        {
            if (jobcodeResponse.success && jobcodeResponse.jobCode)
            {
                this.selectedJobCodeId = jobcodeResponse.jobCodeId ? jobcodeResponse.jobCodeId : this.selectedJobCodeId;
                this.selectedJobCodeData = jobcodeResponse.jobCode;
                this.selectedJobCodeSubject.next(this.selectedJobCodeData);
            }
        }
        function onJobCodeFault(error: any)
        {
            //EmployeeService.logger.error(`processEmployees Fault - Error (${JSON.stringify(error)})`);
        }
    }

    public setJobSubmissionDataInList()
    {
        const index = this.jobSubmissionData.findIndex(x => x.jobSubmissionId === this.selectedJobSubmissionData.jobSubmissionId);
        this.jobSubmissionData[index] = this.selectedJobSubmissionData;
        this.jobSubmissionSubject.next(this.jobSubmissionData);
    }


    private processJobSubmission(response: Observable<IJobSubmissionResponse>, update: boolean = true): Observable<boolean>
    {
        response.subscribe(onJobSubmissionSuccess.bind(this), onJobSubmissionFault.bind(this));
        return response.pipe(mergeMap((response: IJobSubmissionResponse) => observableOf(response.success)),
            catchError(() => observableOf(false)),
            share());
        function onJobSubmissionSuccess(jobSubmissionResponse: IJobSubmissionResponse)
        {
            if (jobSubmissionResponse.success && jobSubmissionResponse.jobSubmission)
            {
                this.selectedJobSubmissionId = jobSubmissionResponse.jobSubmissionId ? jobSubmissionResponse.jobSubmissionId : this.selectedJobSubmissionId;
                this.selectedJobSubmissionData = jobSubmissionResponse.jobSubmission;
                this.selectedJobSubmissionSubject.next(this.selectedJobSubmissionData);
                this.setJobSubmissionDataInList();
            }
        }
        function onJobSubmissionFault(error: any)
        {
            //EmployeeService.logger.error(`processEmployees Fault - Error (${JSON.stringify(error)})`);
        }
    }

    private processMultiJobSubmissions(response: Observable<ICreateMultiSelectCJCResponse>): Observable<ICreateMultiSelectCJCResponse>
    {
        response.subscribe(onJobSubmissionSuccess.bind(this), onJobSubmissionFault.bind(this));
        return response.pipe(mergeMap((response: ICreateMultiSelectCJCResponse) => observableOf(response)),
            catchError(() => observableOf({ success: false, created: [], skipped: [], createdCount: 0, skippedCount: 0 } as ICreateMultiSelectCJCResponse)),
            share());
        function onJobSubmissionSuccess(jobSubmissionResponse: ICreateMultiSelectCJCResponse)
        {
            if (jobSubmissionResponse.success && jobSubmissionResponse.created.length > 0)
            {
                if (this.jobSubmissionData)
                {
                    this.jobSubmissionData.push(...jobSubmissionResponse.created);
                    this.jobSubmissionSubject.next(this.jobSubmissionData);
                }
            }
        }
        function onJobSubmissionFault(error: any)
        {
            //EmployeeService.logger.error(`processEmployees Fault - Error (${JSON.stringify(error)})`);
        }
    }


    private processJobSubmissions(response: Observable<IJobSubmissionResponse>): Observable<boolean>
    {
        response.subscribe(onJobCodeSuccess.bind(this), onJobCodeFault.bind(this));
        return response.pipe(mergeMap((response: IJobSubmissionResponse) => observableOf(response.success)),
            catchError(() => observableOf(false)),
            share());
        function onJobCodeSuccess(jobSubmissionResponse: IJobSubmissionResponse)
        {
            if (jobSubmissionResponse.success && jobSubmissionResponse.jobSubmissions.length > 0)
            {
                this.selectedJobSubmissionId = jobSubmissionResponse.jobSubmissionId ? jobSubmissionResponse.jobSubmissionId : this.selectedJobSubmissionId;
                this.jobSubmissionData = jobSubmissionResponse.jobSubmissions;
                this.jobSubmissionSubject.next(this.jobSubmissionData);
            }
        }
        function onJobCodeFault(error: any)
        {
            //EmployeeService.logger.error(`processEmployees Fault - Error (${JSON.stringify(error)})`);
        }
    }

    private processClientspoc(clientSpoc: Observable<IClientSpocResponse>, update: boolean = true): Observable<boolean>
    {
        clientSpoc.subscribe(onClientSpocSuccess.bind(this), onClientSpocFault.bind(this));
        return clientSpoc.pipe(mergeMap((response: any) => !response ? observableOf(false) : observableOf(true)),
            catchError(() => observableOf(false)),
            share());

        function onClientSpocSuccess(candidateResponse: IClientSpocResponse)
        {
            if (candidateResponse.success && candidateResponse.clientSpoc)
            {
                this.selectedClientSpocId = candidateResponse.clientSpocId ? candidateResponse.clientSpocId : this.selectedClientSpocId;
                this.selectedClientSpocData = candidateResponse.clientSpoc;
                this.selectedClientSpocSubject.next(this.selectedClientSpocData);
                if (this.clientSpocData)
                {
                    if (update)
                    {
                        let data = this.clientSpocData;
                        const index = this.clientSpocData.findIndex(x => x.clientSpocId === this.selectedClientSpocData.clientSpocId);
                        this.clientSpocData[index] = this.selectedClientSpocData;
                        data = this.clientSpocData.filter(x => x.status === this.filterClientSpocStatus);
                        this.clientSpocFilteredSubject.next(data);
                    }
                    else
                    {
                        this.clientSpocData.push(candidateResponse.clientSpoc);
                        this.clientSpocFilteredSubject.next(this.clientSpocData.filter(x => x.status == true));
                    }
                }
            }
        }
        function onClientSpocFault(error: any)
        {
            //EmployeeService.logger.error(`processEmployees Fault - Error (${JSON.stringify(error)})`);
        }
    }

    private processClientspocs(response: Observable<IClientSpocResponse>): Observable<boolean>
    {
        response.subscribe(onClientSpocSuccess.bind(this), onClientSpocFault.bind(this));
        return response.pipe(mergeMap((response: IClientSpocResponse) => observableOf(response.success)),
            catchError(() => observableOf(false)),
            share());
        function onClientSpocSuccess(clientSpocResponse: IClientSpocResponse)
        {
            if (clientSpocResponse.success && clientSpocResponse.clientSpocs.length > 0)
            {
                this.selectedClientSpocId = clientSpocResponse.clientSpocId ? clientSpocResponse.clientSpocId : this.selectedClientSpocId;
                this.clientSpocData = clientSpocResponse.clientSpocs;
                this.clientSpocSubject.next(this.clientSpocData);
                this.getClientspocByStatus(this.filterClientSpocStatus);
            }
        }
        function onClientSpocFault(error: any)
        {
            //EmployeeService.logger.error(`processEmployees Fault - Error (${JSON.stringify(error)})`);
        }
    }

    private processClient(response: Observable<IClientResponses>): Observable<boolean>
    {
        response.subscribe(onClientSpocSuccess.bind(this), onClientSpocFault.bind(this));
        return response.pipe(mergeMap((response: IClientResponses) => observableOf(response.success)),
            catchError(() => observableOf(false)),
            share());
        function onClientSpocSuccess(clientResponse: IClientResponses)
        {
            if (clientResponse.success && clientResponse.client)
            {
                this.selectedClientId = clientResponse.clientId ? clientResponse.clientId : this.selectedClientId;
                this.selectedClientspocClientData = clientResponse.client;
                this.selectedClientspocClientSubject.next(this.selectedClientspocClientData);
            }
        }
        function onClientSpocFault(error: any)
        {
            //EmployeeService.logger.error(`processEmployees Fault - Error (${JSON.stringify(error)})`);
        }
    }

    private processInterviewPanel(response: Observable<IInterViewPanelResponse>): Observable<boolean>
    {
        response.subscribe(onInterviewSuccess.bind(this), onInterviewfault.bind(this));
        return response.pipe(mergeMap((response: IInterViewPanelResponse) => observableOf(response.success)),
            catchError(() => observableOf(false)),
            share());
        function onInterviewSuccess(interview: IInterViewPanelResponse)
        {
            if (interview.success && interview.interviewPanelAvailability)
            {
                this.selectedInterviewPanelId = interview.interviewPanelAvailabilityId ? interview.interviewPanelAvailabilityId : this.selectedInterviewPanelId
                this.selectedInterviewPanelData = interview.interviewPanelAvailability;
                this.selectedInterviewPanelSubject.next(this.selectedInterviewPanelData)
            }
        }
        function onInterviewfault(error: any)
        {
            //EmployeeService.logger.error(`processEmployees Fault - Error (${JSON.stringify(error)})`);
        }

    }

    private processInterviewPanels(response: Observable<IInterViewPanelResponse>): Observable<boolean>
    {
        response.subscribe(onInterviewSuccess.bind(this), onInterviewfault.bind(this));
        return response.pipe(mergeMap((response: IInterViewPanelResponse) => observableOf(response.success)),
            catchError(() => observableOf(false)),
            share());
        function onInterviewSuccess(interview: IInterViewPanelResponse)
        {
            if (interview.success && interview.interviewPanelAvailabilities)
            {
                this.interviewPanelData = interview.interviewPanelAvailabilities;
                this.interviewPanelSubject.next(this.interviewPanelData)
            }
        }
        function onInterviewfault(error: any)
        {
            //EmployeeService.logger.error(`processEmployees Fault - Error (${JSON.stringify(error)})`);
        }
    }

    private processJobInterviews(response: Observable<IJobInterviewResponse>): Observable<boolean>
    {
        response.subscribe(onJobCodeSuccess.bind(this), onJobCodeFault.bind(this));
        return response.pipe(mergeMap((response: IJobCodeResponse) => observableOf(response.success)),
            catchError(() => observableOf(false)),
            share());
        function onJobCodeSuccess(jobInterviewResponse: IJobInterviewResponse)
        {
            if (jobInterviewResponse.success && jobInterviewResponse.jobInterviews.length > 0)
            {
                this.selectedJobInterviewId = jobInterviewResponse.jobInterviewId ? jobInterviewResponse.jobInterviewId : this.selectedJobInterviewId;
                this.interviewData = jobInterviewResponse.jobInterviews;
                this.interviewSubject.next(this.interviewData)
            }
        }
        function onJobCodeFault(error: any)
        {
            //EmployeeService.logger.error(`processEmployees Fault - Error (${JSON.stringify(error)})`);
        }
    }

    private processJobInterview(response: Observable<IJobInterviewResponse>, update: boolean = true): Observable<boolean>
    {
        response.subscribe(onJobInterviewSuccess.bind(this), onJobInterviewFault.bind(this));
        return response.pipe(mergeMap((response: IJobCodeResponse) => observableOf(response.success)),
            catchError(() => observableOf(false)),
            share());
        function onJobInterviewSuccess(jobInterviewResponse: IJobInterviewResponse)
        {
            if (jobInterviewResponse.success && jobInterviewResponse.jobInterview)
            {
                this.selectedJobInterviewId = jobInterviewResponse.jobInterviewId ? jobInterviewResponse.jobInterviewId : this.selectedJobInterviewId;
                this.selectedJobInterviewData = jobInterviewResponse.jobInterview;
                this.selectedJobInterviewSubject.next(this.selectedJobInterviewData);
                if (this.interviewData)
                {
                    if (update)
                    {
                        const index = this.interviewData.findIndex(x => x.jobInterviewId === this.selectedJobInterviewData.jobInterviewId);
                        this.interviewData[index] = this.selectedJobInterviewData;
                        this.interviewSubject.next(this.interviewData);
                    }
                    else
                    {
                        this.interviewData.push(jobInterviewResponse.jobInterview);
                        this.interviewSubject.next(this.interviewData);
                    }
                }
            }
        }
        function onJobInterviewFault(error: any)
        {
            //EmployeeService.logger.error(`processEmployees Fault - Error (${JSON.stringify(error)})`);
        }
    }
}
